//====================================================
//  Function: Shoptet events
//====================================================

function baseEvents() {
	hideFlagSaleInSaleCategory();
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    partsRepositionProducts();
    addPaginationScroll();
    repositionFilterSections();
    hideFlagSaleInSaleCategory();
    initYotpoCategoryStars();
    addImageBadgeProduct();
    addBadgePexesoProduct();
    if (window.addBadge5Category === true && typeof window.addBadge5MinPrice !== 'undefined') {
      addBadge5LowPriorityProduct();
    }
    yotpoWidgetsContainer.initWidgets();
    //stockAvailabilityProductCardTest2();
  });

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    componentsCheckout();
    giftPlugin();
    initYotpoCategoryStars();
    addImageBadgeProduct();
    addBadgePexesoProduct();
    if (window.addBadge5Category === true && typeof window.addBadge5MinPrice !== 'undefined') {
      addBadge5LowPriorityProduct();
    }
  });

  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    //TODO - new style notification - not finished and not contains 100% use cases
    //partsRepositionProducts();
    //partsRepositionAdvancedOrder();
    upsellGrateCartUpdate();
    customMattressNotice();
  });

  document.addEventListener("shoptet.modal.open", function () {
    $("#colorbox").removeClass("advanced-order-modal");
  });

  document.addEventListener("ShoptetDOMPageContentLoaded", function () {
    repositionFilterSections();
    addPaginationScroll();
    freeDeliveryInCategory();
    dimensionFlagInCategory();
    mattressSpecialDescriptionCategory();

    if($('#products').length) {
      calculateDiscountListing();
      dropdownProductSorting();
      initYotpoCategoryStars();
      //stockAvailabilityProductCardTest2();
    }
    if ($('.category-perex').length) {
      topDescriptionShowLessMoreText();
    }
  });

  document.addEventListener("ShoptetPageFilterValueChange", function () {
    isFilterChanged = true;
  });

  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    if($('#products').length) {
      calculateDiscountListing();
      //stockAvailabilityProductCardTest2();
    }
  });

  document.addEventListener('ShoptetVariantAvailable', function () {
    addMOCLabel();
  });

  document.addEventListener('ShoptetSplitVariantParameterChange', function () {
    addMOCLabel();
  });
}
